module.exports = __webpack_public_path__ + "bb5254487d388c05b3aa2e5b614ec558.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/binoculars.png
// module id = 2310
// module chunks = 0